
import React from "react";
import StatusBadge from "./StatusBadge";

interface AdminCriteriaSectionProps {
  verificationResult: any;
}

const AdminCriteriaSection: React.FC<AdminCriteriaSectionProps> = ({ verificationResult }) => {
  return (
    <section>
      <h3 className="text-lg font-medium mb-2">Admin Criteria</h3>
      <p className="text-sm text-gray-500 mb-4">A user is considered an admin if ANY of these are true:</p>
      
      <div className="space-y-3">
        <div className="flex items-center justify-between p-3 border rounded-md">
          <div>
            <div className="font-medium">Special Admin Email</div>
            <div className="text-sm text-gray-500">Email matches hardcoded admin addresses</div>
          </div>
          <StatusBadge condition={!!verificationResult?.details?.specialEmail} />
        </div>
        
        <div className="flex items-center justify-between p-3 border rounded-md">
          <div>
            <div className="font-medium">User Metadata</div>
            <div className="text-sm text-gray-500">User has admin flag in metadata</div>
          </div>
          <StatusBadge condition={!!verificationResult?.details?.userMetadata} />
        </div>
        
        <div className="flex items-center justify-between p-3 border rounded-md">
          <div>
            <div className="font-medium">Profile Role</div>
            <div className="text-sm text-gray-500">User has admin role in profiles table</div>
          </div>
          <StatusBadge condition={!!verificationResult?.details?.profileRole} />
        </div>
      </div>
    </section>
  );
};

export default AdminCriteriaSection;
